
export const ProductBoxId = Object.freeze({
    CPC: '134 ',
    NEXT: '158 ',
    RENTING: '132 ',
    LINEAL: '133 ',
    REFINANCIACION_CPC: '141 ',
    REFINANCIACION_NEXT: '168 ',
    AUTOCREDIT: '166 '
});